import update from 'immutability-helper';
import { createSwitch, createCase } from 'helpers/action-helpers';
import { initialState } from './state';
import { SetNotificationsAction, DismissNotificationAction } from './actions';
import { Notification } from 'types/notification';

export const notificationsReducer = createSwitch(initialState, [
  createCase(new SetNotificationsAction([]), (state, action) => {
    const visibleNotification = getVisibleNotification(action.notifications);
    return update(state, {
      visibleNotification: { $set: visibleNotification },
      notifications: { $set: action.notifications },
    });
  }),
  createCase(new DismissNotificationAction(''), (state, action) => {
    const notifications = state.notifications.filter((notification) => {
      return notification.id !== action.notificationId;
    });
    const visibleNotification = getVisibleNotification(notifications);
    return update(state, {
      visibleNotification: { $set: visibleNotification },
      notifications: { $set: notifications }
    });
  })
]);

function getVisibleNotification(notifications: Notification[]): Notification | null {
  if (notifications.length) {
    return notifications[0];
  }
  return null;
}


// WEBPACK FOOTER //
// ./src/components/notification/reducer.ts